import React from 'react';
import Box from '@mui/material/Box';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { ArrowBackIcon, ClearIcon } from 'components/icons';
import { useActiveVehicle } from '../../../context/ActiveVehicleProvider';
import LocationComponent from '../../locationComponent/LocationComponent';
import { TOW_BRANCH, getStage } from '../../../flow/stages';

interface ActiveVehicleDrawerHeaderProps {}

const ActiveVehicleDrawerHeader: React.FC<ActiveVehicleDrawerHeaderProps> = () => {
	const {
		stage,
		pipeline,
		currentIndex,
		canGoBack,
		goBack,
		goTo,
		closeDrawer,
		parkingLocation,
	} = useActiveVehicle();

	// Branch stages (towInfo) are not in the linear pipeline. Their back target
	// is hand-wired to ticket. Keep this as the only special case so the linear
	// path stays fully data-driven.
	const onTowBranch = stage === TOW_BRANCH.id;
	const onAction = stage === 'action' && currentIndex === 0;

	let backLabel: string | null = null;
	let backHandler: (() => void) | null = null;

	if (onTowBranch) {
		backLabel = `Back to ${getStage('ticket').label.toLowerCase()}`;
		backHandler = () => goTo('ticket');
	} else if (canGoBack) {
		backLabel = `Back to ${pipeline[currentIndex - 1].label.toLowerCase()}`;
		backHandler = goBack;
	}

	return (
		<Box
			style={{
				display: 'flex',
				justifyContent: 'space-between',
			}}
		>
			{onAction && (
				<LocationComponent
					parkingLocationName={parkingLocation?.name || ''}
				/>
			)}
			{backLabel && backHandler && (
				<Box
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: '0.5rem',
					}}
				>
					<IconButton onClick={backHandler}>
						<ArrowBackIcon />
					</IconButton>
					<Box onClick={backHandler} sx={{ cursor: 'pointer' }}>
						<Typography variant="caption">{backLabel}</Typography>
					</Box>
				</Box>
			)}

			<Box>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
					}}
				>
					<Tooltip title="Close">
						<IconButton onClick={closeDrawer}>
							<ClearIcon />
						</IconButton>
					</Tooltip>
				</Box>
			</Box>
		</Box>
	);
};

export default ActiveVehicleDrawerHeader;
